import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Row, Col, Button } from "react-bootstrap";
import { unAuthService } from "Service/Axios";
import {
  CREATE_OTP_URL,
  RESET_PASSWORD_URL,
  VALIDATE_OTP_URL,
} from "Constant/api";
import { Alerts, ButtonLoader } from "Components";
import { useTimer } from "Utils/hooks/useTimer";
import { Validator } from "Utils/validator";
import { paths } from "Constant/paths";

export default function ForgetPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("password");

  const [formData, setFormData] = useState({
    email: "",
    otp: "",
  });
  const [errMsg, setErrMsg] = useState({
    email: "",
    otp: "",
    inValid: "",
  });

  const { email, otp } = formData;

  const { timeLeft, formatedTime, setTimeLeft } = useTimer();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    setErrMsg((prev) => ({
      ...prev,
      inValid: "",
      otp: "",
    }));
    if (e.target.name === "email") {
      if (!e.target.value) {
        setErrMsg((prev) => ({
          ...prev,
          email: t("common.messages.error.common.email.blank"),
        }));
      } else if (e.target.value && !Validator.email(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          email: t("common.messages.error.common.email.inValid"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          email: "",
        }));
      }
    }
  };

  const handlePaste = (e) => {
    const pastedValue = e.clipboardData.getData("Text");

    if (pastedValue.length === 6) {
      setFormData({
        ...formData,
        otp: pastedValue,
      });
    }
  };

  const getValidation = () => {
    return new Promise((resolve) => {
      if (email && Validator.email(email)) {
        resolve(true);
      } else {
        if (!email) {
          setErrMsg((prev) => ({
            ...prev,
            email: t("common.messages.error.common.email.blank"),
          }));
        } else if (email && !Validator.email(email)) {
          setErrMsg((prev) => ({
            ...prev,
            email: t("common.messages.error.common.email.inValid"),
          }));
        }
        resolve(false);
      }
    });
  };

  const onSubmitForgetPassword = async (e) => {
    e.preventDefault();
    const validationStatus = await getValidation();
    if (validationStatus) {
      setLoading(true);
      const payload = {
        username: email,
        email,
      };
      const response = await unAuthService(RESET_PASSWORD_URL, "POST", payload);
      if (response && response.success) {
        setLoading(false);
        if (response.message === "Email has been sent") {
          setStep("otp");
          setTimeLeft(120);
          toast.success(t("common.messages.notification.success.oTPSent"));
        }
      } else {
        if (response?.message === "There is no user with this id") {
          setErrMsg((prev) => ({
            ...prev,
            inValid: t("common.messages.error.common.email.notExist"),
          }));
        } else if (
          response?.message ===
          "Your account has not been activated. Please register once again"
        ) {
          setErrMsg((prev) => ({
            ...prev,
            inValid: t("common.messages.error.guest.login.inactiveUser"),
          }));
        }
        setLoading(false);
      }
    }
  };

  const onGenerateOtp = async () => {
    setLoading(true);
    setTimeLeft(120);
    const payload = {
      username: email,
    };
    const response = await unAuthService(CREATE_OTP_URL, "POST", payload);
    if (response && response.message === "Email has been sent") {
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const onSubmitOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      otp,
      email,
    };
    const response = await unAuthService(VALIDATE_OTP_URL, "POST", payload);
    if (response) {
      setLoading(false);
      if (response.message === "The otp is valid") {
        navigate(paths.resetPassword, {
          state: {
            email,
            firstName: response.firstName,
            lastName: response.lastName,
          },
        });
      } else {
        setErrMsg((prev) => ({
          ...prev,
          otp: t("common.messages.notification.failed.wrongOtp"),
        }));
      }
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      {step === "password" && (
        <div className="px-lg-4 d-flex flex-column justify-content-center max-w-400 mx-auto login-box w-100">
          <div className="mb-5">
            <h3 className="text-xl-4xl text-2xl font-semibold">
              {t("common.button.forgotPassword")}
            </h3>
            <div className="text-sm text-grey-600">
              Already have an account?{" "}
              <Link
                to={paths.login}
                className="text-primary-500 text-decoration-none font-medium"
              >
                {t("common.button.signIn")}
              </Link>
            </div>
          </div>

          <form className="" onSubmit={onSubmitForgetPassword}>
            <div className="mb-4">
              <label htmlFor="login-email" className="form-label">
                {t("common.label.email")}
              </label>
              <div className="input-group position-relative">
                <input
                  type="email"
                  className="form-control form-control-lg pr-10 rounded-lg"
                  id="login-email"
                  placeholder={t("common.placeHolder.email")}
                  name="email"
                  value={email}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="border-start-0 position-absolute top-0 end-0 bottom-0 w-10 d-flex justify-content-center align-items-center text-grey-300 border-0 bg-transparent z-5"
                >
                  <i className="bx bx-at"></i>
                </button>
              </div>
              {errMsg.email && <p className="error">{errMsg.email}</p>}
            </div>
            {errMsg.inValid && (
              <Alerts variant="danger" message={errMsg.inValid} />
            )}
            <div className="d-grid">
              {!loading ? (
                <button
                  type="submit"
                  className="btn btn-primary btn-lg rounded-lg"
                >
                  {t("common.button.submit")}
                </button>
              ) : (
                <ButtonLoader />
              )}
            </div>
          </form>

          <div className="text-center mt-5 text-sm">
            <span className="text-grey-400">
              By signing up to create an account I accept Company’s
              <br />
              <a
                href="#"
                className="text-decoration-none font-semibold text-grey-700"
              >
                Terms of use & Privacy Policy.
              </a>
            </span>
          </div>
        </div>
      )}

      {step === "otp" && (
        <div className="px-lg-4 d-flex flex-column justify-content-center max-w-400 mx-auto">
          <div className="mb-5">
            <h3 className="text-xl-4xl text-2xl font-semibold">
              Verify your email
            </h3>
            <div className="text-sm text-grey-600">
              We sent a code to{" "}
              <span
                href="#"
                className="text-primary-600 text-decoration-none font-medium border-0 bg-primary-50 ms-1 px-3 py-1 rounded-md"
              >
                {email}
              </span>
            </div>
          </div>
          <Row>
            <Col sm={12} xs={12}>
              <div className="otp-form mb-4">
                <div className="mb-3">
                  <label className="mb-1" htmlFor="otp">
                    Enter Verification Code
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-lg rounded-2"
                    placeholder="XXXXXX"
                    id="otp"
                    name="otp"
                    value={otp}
                    onChange={handleChange}
                    onPaste={handlePaste}
                    maxLength={6}
                  />
                </div>
              </div>
              {errMsg.otp && <Alerts variant="danger" message={errMsg.otp} />}
            </Col>
            <div className="mb-4 text-sm">
              {timeLeft > 0 ? (
                <span>Resend OTP in {formatedTime}</span>
              ) : (
                <>
                  Didn’t get a code?
                  <button
                    type="button"
                    className="text-primary-600 text-decoration-none font-medium border-0 bg-primary-50 ms-1 px-3 py-1 rounded-md"
                    onClick={onGenerateOtp}
                  >
                    Resend Code
                  </button>
                </>
              )}
            </div>
            <Col sm={12} xs={12}>
              {!loading ? (
                <Button
                  variant="primary"
                  size="lg"
                  className="w-100 font-medium"
                  onClick={onSubmitOTP}
                >
                  {t("common.button.verify")}
                </Button>
              ) : (
                <ButtonLoader />
              )}
            </Col>
          </Row>

          <div className="text-center mt-5 text-sm">
            <span className="text-grey-400">
              By signing up to create an account I accept Company’s
              <br />
              <a
                href="#"
                className="text-decoration-none font-semibold text-grey-700"
              >
                Terms of use & Privacy Policy.
              </a>
            </span>
          </div>
        </div>
      )}
    </>
  );
}
